export { MORPHEME_TILE_DELAY_LONG_PRESS_MS } from "#morpheme-tile-delay-long-press-ms";
export {
  MORPHEME_STAGE_BACKGROUND_CLASSES,
  morphemeGlyphTileVariants,
} from "#morpheme-glyph-tile-variants";
